import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=721bebfb&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=721bebfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721bebfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('721bebfb')) {
      api.createRecord('721bebfb', component.options)
    } else {
      api.reload('721bebfb', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=721bebfb&scoped=true&", function () {
      api.rerender('721bebfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-299z7wGPT8D3m/JS/comp/PopupBox.vue"
export default component.exports